import loadCards from '../action/loadCards';
import loadDocument from '../action/loadDocument';
import loadLandingPage from '../action/loadLandingPage';
import loadPageTitle from '../action/loadPageTitle';
import loadQuickstarts from '../action/loadQuickstarts';
import tutorialNavigatorActions from '../action/tutorialNavigatorActions';
import { ArticleType } from '../components/Article';
import ArticlePage from '../components/pages/ArticlePage';
import AuthApiPage from '../components/pages/AuthApiPage';
import AuthExtensionPage from '../components/pages/AuthExtensionPage';
import ErrorPage from '../components/pages/ErrorPage';
import GlossaryPage from '../components/pages/GlossaryPage';
import HomePage from '../components/pages/HomePage';
import LibraryPage from '../components/pages/LibraryPage';
import { LoadingPage } from '../components/pages/LoadingPage';
import QuickstartsPage from '../components/pages/QuickstartsPage.new';
import SearchPage from '../components/pages/SearchPage';
import { TutorialPage } from '../components/pages/TutorialPage';
import normalizeUrl from '../util/normalizeUrl';
export default {
    home: {
        path: '/docs',
        method: 'get',
        handler: HomePage,
        action: function (context) {
            return Promise.all([loadQuickstarts(context).then(function () { return tutorialNavigatorActions.home(context); }), loadCards(context)]);
        },
    },
    search: {
        path: '/docs/search',
        method: 'get',
        handler: SearchPage,
        action: loadPageTitle,
    },
    searchfrca: {
        path: '/docs/:locale/search',
        method: 'get',
        handler: SearchPage,
        action: loadPageTitle,
    },
    // searchjajp: {
    //   path: '/docs/ja-jp/search',
    //   method: 'get',
    //   handler: SearchPage,
    //   action: loadPageTitle,
    // },
    glossary: {
        path: '/docs/glossary',
        method: 'get',
        handler: GlossaryPage,
        action: loadPageTitle,
    },
    glossarylocale: {
        path: '/docs/:locale/glossary',
        method: 'get',
        handler: GlossaryPage,
        action: loadPageTitle,
    },
    library: {
        path: '/docs/libraries',
        method: 'get',
        handler: LibraryPage,
        action: loadQuickstarts,
    },
    libraryfrca: {
        path: '/docs/:locale/libraries',
        method: 'get',
        handler: LibraryPage,
        action: loadQuickstarts,
    },
    // libraryjajp: {
    //   path: '/docs/ja-jp/libraries',
    //   method: 'get',
    //   handler: LibraryPage,
    //   action: loadQuickstarts,
    // },
    authApiExplorer: {
        path: '/docs/api/authentication',
        method: 'get',
        section: 'apis',
        handler: AuthApiPage,
        action: loadDocument,
    },
    authApiExplorerfrca: {
        path: '/docs/:locale/api/authentication',
        method: 'get',
        section: 'apis',
        handler: AuthApiPage,
        action: loadDocument,
    },
    // authApiExplorerjajp: {
    //   path: '/docs/ja-jp/api/authentication',
    //   method: 'get',
    //   section: 'apis',
    //   handler: AuthApiPage,
    //   action: loadDocument,
    // },
    authExtensionExplorer: {
        path: '/docs/api/authorization-extension',
        method: 'get',
        section: 'apis',
        handler: AuthExtensionPage,
        action: loadDocument,
    },
    authExtensionExplorerfrca: {
        path: '/docs/:locale/api/authorization-extension',
        method: 'get',
        section: 'apis',
        handler: AuthExtensionPage,
        action: loadDocument,
    },
    // authExtensionExplorerjajp: {
    //   path: '/docs/ja-jp/api/authorization-extension',
    //   method: 'get',
    //   section: 'apis',
    //   handler: AuthExtensionPage,
    //   action: loadDocument,
    // },
    contentful: {
        path: '/docs/contentful/:contentfulId',
        method: 'get',
        handler: ArticlePage,
        action: loadDocument,
    },
    contentfulfrca: {
        path: '/docs/fr-ca/contentful/:contentfulId',
        method: 'get',
        handler: ArticlePage,
        action: function (context, payload) {
            payload.params.locale = 'fr-CA';
            return loadDocument(context, payload);
        },
    },
    contentfuljajp: {
        path: '/docs/ja-jp/contentful/:contentfulId',
        method: 'get',
        handler: ArticlePage,
        action: function (context, payload) {
            payload.params.locale = 'ja-JP';
            return loadDocument(context, payload);
        },
    },
    apiDocs: {
        path: '/docs/api/management/*',
        method: 'get',
        handler: LoadingPage,
        action: function (context, payload) {
            if (typeof window !== 'undefined') {
                window.history.pushState({}, '', normalizeUrl(payload.url));
                window.history.go();
            }
        },
    },
    // apiDocsfrca: {
    //   path: '/docs/:locale/api/management/*',
    //   method: 'get',
    //   handler: LoadingPage,
    //   action: (context: any, payload: any) => {
    //     if (typeof window !== 'undefined') {
    //       window.history.pushState({}, '', normalizeUrl(payload.url));
    //       window.history.go();
    //     }
    //   },
    // },
    // apiDocsjajp: {
    //   path: '/docs/ja-jp/api/management/*',
    //   method: 'get',
    //   handler: LoadingPage,
    //   action: (context: any, payload: any) => {
    //     if (typeof window !== 'undefined') {
    //       window.history.pushState({}, '', normalizeUrl(payload.url));
    //       window.history.go();
    //     }
    //   },
    // },
    homefrca: {
        path: '/docs/fr-ca',
        method: 'get',
        handler: HomePage,
        action: function (context, payload) {
            return Promise.all([
                loadQuickstarts(context, { locale: 'fr-ca' }).then(function () { return tutorialNavigatorActions.home(context); }),
                loadCards(context),
            ]);
        },
    },
    homejajp: {
        path: '/docs/ja-jp',
        method: 'get',
        handler: HomePage,
        action: function (context) {
            return Promise.all([
                loadQuickstarts(context, { locale: 'ja-jp' }).then(function () { return tutorialNavigatorActions.home(context); }),
                loadCards(context),
            ]);
        },
    },
    errorPage: {
        path: '/docs/error',
        method: 'get',
        handler: ErrorPage,
    },
    quickstarts: {
        path: '/docs/quickstarts',
        method: 'get',
        section: 'quickstarts',
        handler: QuickstartsPage,
        action: function (context) { return loadQuickstarts(context).then(function () { return tutorialNavigatorActions.quickstartList(context); }); },
    },
    // quickstartsjajp: {
    //   path: '/docs/ja-jp/quickstarts',
    //   method: 'get',
    //   section: 'quickstarts',
    //   handler: QuickstartsPage,
    //   action: (context: any) => loadQuickstarts(context).then(() => tutorialNavigatorActions.quickstartList(context)),
    // },
    quickstartAppType: {
        path: '/docs/quickstart/:quickstartId',
        method: 'get',
        section: 'quickstarts',
        handler: QuickstartsPage,
        action: function (context, payload) {
            return loadQuickstarts(context).then(function () { return tutorialNavigatorActions.quickstart(context, payload); });
        },
    },
    quickstartAppTypeLocale: {
        path: '/docs/:locale/quickstart/:quickstartId',
        method: 'get',
        section: 'quickstarts',
        handler: QuickstartsPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.quickstart(context, payload);
            });
        },
    },
    quickstartsfrca: {
        path: '/docs/:locale/quickstarts',
        method: 'get',
        section: 'quickstarts',
        handler: QuickstartsPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.quickstartList(context);
            });
        },
    },
    quickstartAppTypefrca: {
        path: '/docs/:locale/quickstart/:quickstartId',
        method: 'get',
        section: 'quickstarts',
        handler: QuickstartsPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.quickstart(context, payload);
            });
        },
    },
    // quickstartAppTypejajp: {
    //   path: '/docs/ja-jp/quickstart/:quickstartId',
    //   method: 'get',
    //   section: 'quickstarts',
    //   handler: QuickstartsPage,
    //   action: (context: any, payload: any) =>
    //     loadQuickstarts(context).then(() => tutorialNavigatorActions.quickstart(context, payload)),
    // },
    quickstartPlatform: {
        path: '/docs/quickstart/:quickstartId/:platformId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            return loadQuickstarts(context).then(function () { return tutorialNavigatorActions.platform(context, payload); });
        },
    },
    quickstartPlatformfrca: {
        path: '/docs/:locale/quickstart/:quickstartId/:platformId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.platform(context, payload);
            });
        },
    },
    // quickstartPlatformjajp: {
    //   path: '/docs/ja-jp/quickstart/:quickstartId/:platformId',
    //   method: 'get',
    //   section: 'quickstarts',
    //   handler: TutorialPage,
    //   action: (context: any, payload: any) =>
    //     loadQuickstarts(context).then(() => tutorialNavigatorActions.platform(context, payload)),
    // },
    quickstartArticleOrVersion: {
        path: '/docs/quickstart/:quickstartId/:platformId/:versionOrArticleId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            return loadQuickstarts(context).then(function () { return tutorialNavigatorActions.article(context, payload); });
        },
    },
    quickstartArticleOrVersionfrca: {
        path: '/docs/:locale/quickstart/:quickstartId/:platformId/:versionOrArticleId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.article(context, payload);
            });
        },
    },
    // quickstartArticleOrVersionjajp: {
    //   path: '/docs/ja-jp/quickstart/:quickstartId/:platformId/:versionOrArticleId',
    //   method: 'get',
    //   section: 'quickstarts',
    //   handler: TutorialPage,
    //   action: (context: any, payload: any) =>
    //     loadQuickstarts(context).then(() => tutorialNavigatorActions.article(context, payload)),
    // },
    quickstartArticleWithVersion: {
        path: '/docs/quickstart/:quickstartId/:platformId/:versionId/:articleId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.article(context, payload);
            });
        },
    },
    quickstartArticleWithVersionfrca: {
        path: '/docs/:locale/quickstart/:quickstartId/:platformId/:versionId/:articleId',
        method: 'get',
        section: 'quickstarts',
        handler: TutorialPage,
        action: function (context, payload) {
            var _a;
            return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.params) === null || _a === void 0 ? void 0 : _a.locale }).then(function () {
                return tutorialNavigatorActions.article(context, payload);
            });
        },
    },
    // quickstartArticleWithVersionjajp: {
    //   path: '/docs/ja-jp/quickstart/:quickstartId/:platformId/:versionId/:articleId',
    //   method: 'get',
    //   section: 'quickstarts',
    //   handler: TutorialPage,
    //   action: (context: any, payload: any) =>
    //     loadQuickstarts(context).then(() => tutorialNavigatorActions.article(context, payload)),
    // },
    article: {
        path: '/docs/*',
        method: 'get',
        handler: ArticlePage,
        action: function (context, payload) {
            return loadDocument(context, payload).then(function (doc) {
                var _a;
                if (((_a = doc === null || doc === void 0 ? void 0 : doc.meta) === null || _a === void 0 ? void 0 : _a.type) === ArticleType.LandingPage) {
                    return loadLandingPage(context, { doc: doc });
                }
            });
        },
    },
    articlefrca: {
        path: '/docs/fr-ca/*',
        method: 'get',
        handler: ArticlePage,
        action: function (context, payload) {
            return loadDocument(context, payload).then(function (doc) {
                var _a;
                if (((_a = doc === null || doc === void 0 ? void 0 : doc.meta) === null || _a === void 0 ? void 0 : _a.type) === ArticleType.LandingPage) {
                    return loadLandingPage(context, { doc: doc });
                }
            });
        },
    },
    articlejajp: {
        path: '/docs/ja-jp/*',
        method: 'get',
        handler: ArticlePage,
        action: function (context, payload) {
            return loadDocument(context, payload).then(function (doc) {
                var _a;
                if (((_a = doc === null || doc === void 0 ? void 0 : doc.meta) === null || _a === void 0 ? void 0 : _a.type) === ArticleType.LandingPage) {
                    return loadLandingPage(context, { doc: doc });
                }
            });
        },
    },
};
